import { lazy } from 'react';
import { useSessionServiceContext } from '@cld/session-service';

import { RemoteModule } from '../components/remote-module/remote-module';
import { useMessage } from '../i18n/useMessage';
import { useQuerySeed } from '../hooks/util.hooks';
import { useAuthorizeThumbnailsClient, useThumbnailsVisibilityProtection } from '../hooks/thumbnails.hooks';
import { UnicornApi } from '@cld/unicorn-api';

const RemoteDeliveryReports = lazy(() =>
  import('@cld-remote/classic_reports/index').then(({ PMDeliveryReportsPage }) => ({
    default: PMDeliveryReportsPage,
  }))
);

export const DeliveryReports = ({ unicornApi }: { unicornApi: UnicornApi }) => {
  const { productEnvironment } = unicornApi.data;
  const t = useMessage();
  const seed = useQuerySeed();
  const shouldDisplayThumbnail = useThumbnailsVisibilityProtection();
  const authorizeThumbnailsClient = useAuthorizeThumbnailsClient(productEnvironment.cloudName);
  const { authorizedFetch } = useSessionServiceContext();

  return (
    <RemoteModule documentTitle={t('delivery-reports')}>
      <RemoteDeliveryReports
        key={productEnvironment.externalId}
        seed={seed}
        clock={() => new Date()}
        shouldDisplayThumbnail={shouldDisplayThumbnail}
        authorizeThumbnailsClient={authorizeThumbnailsClient}
        fetchClient={authorizedFetch}
        unicornApi={unicornApi}
      />
    </RemoteModule>
  );
};
